module.exports = __webpack_public_path__ + "img/img-box-services-sitebuild-left.7a0eff43.png";